<template>
  <v-app>
    <the-cassa-layout v-if="layout === 'Cassa'"/>
    <the-default-layout v-else-if="layout==='Default'"/>
    <div v-else />
  </v-app>
</template>

<script>
// TODO: Con VITE vedi procedura di abilitazione dinamica https://blog.izem.dev/a-vue-3-users-guide-to-creating-complex-layouts
import TheDefaultLayout from '@/layouts/TheDefaultLayout'
import TheCassaLayout from '@/layouts/TheCassaLayout'

export default {
  name: 'App',
  components: {
    TheDefaultLayout,
    TheCassaLayout
  },

  data: () => ({

  }),
  computed: {
    layout() {
      const route = this.$route;
      const layout = route?.meta?.layout || '';
      return layout;      
    }
  }
};
</script>
